<router-outlet></router-outlet>
<aa-popin-notifications></aa-popin-notifications>
<aa-modal></aa-modal>
<aa-alert></aa-alert>
<aa-chat-bot-widget></aa-chat-bot-widget>